<template>
  <div class="yxtbiz-card-consumpt-audit" v-loading="loading">
    <div class="mb16">
      <span>{{ $t('pc_biz_mall_order_code' /**订单编号 */) }}：{{ info.orderCode }}</span>
      <yxt-button type="text" class="ml16" @click="openDetail">{{ $t('pc_biz_mall_order_detail' /**查看订单详情 */) }}</yxt-button>
    </div>
    <div class="mb16">
      <span>{{ $t('pc_biz_mall_order_sum' /**订单总金额 */) }}：￥{{ info.totalAmount | numWithThousandth }}</span>
    </div>
    <div class="mb16">
      <span>{{ $t('pc_biz_mall_order_time' /**订单创建时间 */) }}：{{ info.createTime }}</span>
    </div>
  </div>
</template>

<script>
import { getOrderInfo } from './service';

export default {
  name: 'YxtbizCardConsumptAudit',
  props: {
    formId: {
      type: String,
      required: true
    }
  },
  filters: {
    numWithThousandth(num) {
      return (+num || 0).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
  },
  data() {
    return {
      loading: true,
      orderId: '',
      info: {
        orderCode: '',
        totalAmount: '',
        createTime: ''
      }
    };
  },
  mounted() {
    this.loading = true;
    getOrderInfo(this.formId)
      .then(res => {
        this.info.orderCode = res.outOrderCode;
        this.info.totalAmount = this.accDiv(res.totalAmount, 100);
        this.info.createTime = res.createTime.split(' ')[0];
        this.orderId = res.outOrderId;
      })
      .finally(() => (this.loading = false));
  },

  methods: {
    // 除法函数，用来得到精确的除法结果
    accDiv(arg1, arg2) {
      if (arg1 === undefined || arg2 === undefined || arg1 === null || arg2 === null) {
        return undefined;
      }
      if (arg2 === 0) {
        return 1;
      }
      let t1 = 0; let t2 = 0;
      try { t1 = arg1.toString().split('.')[1].length; } catch (e) {};
      try { t2 = arg2.toString().split('.')[1].length; } catch (e) {};
      const r1 = Number(arg1.toString().replace('.', ''));
      const r2 = Number(arg2.toString().replace('.', ''));
      return (r1 / r2) * Math.pow(10, t2 - t1);
    },
    openDetail() {
      window.open(`${window.feConfig.common.mall}order/${this.orderId}`, '_blank');
    }
  }
};
</script>